// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3i95e","content":"ManualTimeModal_content__3nzW5"};